import { render, staticRenderFns } from "./news-post-cmp.vue?vue&type=template&id=e82830bc"
import script from "./news-post-cmp.vue?vue&type=script&lang=js"
export * from "./news-post-cmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports